module.exports = __webpack_public_path__ + "img/insurancebanner.1d9cc817.png";